"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SunburstClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const settings_1 = require("../settings");
class SunburstClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getPageEvents(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v1/projects/${request.project}/sunburst/page-events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
}
exports.SunburstClient = SunburstClient;
//# sourceMappingURL=sunburst.client.js.map